/* Purus Ritual — theme.js */
(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const S = () => (window.PurusTheme && window.PurusTheme.strings) || {};
  // Each initialiser marks its root so re-running init (theme editor section reloads) never double-binds.
  const once = (el, key) => { if (!el || el.dataset['init' + key]) return false; el.dataset['init' + key] = '1'; return true; };

  /* ---------- Money ---------- */
  window.PurusMoney = function (cents) {
    const format = (window.PurusTheme && window.PurusTheme.moneyFormat) || '${{amount}}';
    const value = (Number(cents) / 100);
    const re = /\{\{\s*(\w+)\s*\}\}/;
    const m = format.match(re);
    let out;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': out = Math.round(value).toLocaleString('en-AU'); break;
      case 'amount_with_comma_separator': out = value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); break;
      case 'amount_no_decimals_with_comma_separator': out = Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); break;
      default: out = value.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return format.replace(re, out);
  };

  /* ---------- Scroll lock (works on iOS Safari, where overflow:hidden on body is ignored) ---------- */
  const ScrollLock = {
    y: 0, locked: false,
    lock() {
      if (this.locked) return;
      this.y = window.scrollY;
      document.body.style.top = (-this.y) + 'px';
      document.body.classList.add('scroll-locked', 'drawer-open');
      this.locked = true;
    },
    unlock() {
      if (!this.locked) return;
      document.body.classList.remove('scroll-locked', 'drawer-open');
      document.body.style.top = '';
      window.scrollTo({ top: this.y, behavior: 'auto' });
      this.locked = false;
    }
  };

  /* ---------- Overlay + drawers ---------- */
  const overlay = $('[data-overlay]');
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const Drawers = {
    open: null, returnTo: null,
    show(el, opener) {
      if (this.open && this.open !== el) this.hide(this.open, true);
      this.returnTo = opener || document.activeElement;
      el.hidden = false;
      requestAnimationFrame(() => { el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); });
      if (overlay) { overlay.hidden = false; requestAnimationFrame(() => overlay.classList.add('is-visible')); }
      ScrollLock.lock();
      this.open = el;
      const focusable = el.querySelector('[data-autofocus]') || el.querySelector(FOCUSABLE);
      if (focusable) setTimeout(() => focusable.focus({ preventScroll: true }), 120);
      document.dispatchEvent(new CustomEvent('drawer:open', { detail: { drawer: el } }));
    },
    hide(el, keepOverlay) {
      if (!el) return;
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      setTimeout(() => { if (!el.classList.contains('is-open')) el.hidden = true; }, 350);
      if (!keepOverlay) {
        if (overlay) { overlay.classList.remove('is-visible'); setTimeout(() => { if (!overlay.classList.contains('is-visible')) overlay.hidden = true; }, 260); }
        ScrollLock.unlock();
        this.open = null;
        const back = this.returnTo; this.returnTo = null;
        if (back && typeof back.focus === 'function' && document.contains(back)) back.focus({ preventScroll: true });
      }
      document.dispatchEvent(new CustomEvent('drawer:close', { detail: { drawer: el } }));
    },
    toggle(el, opener) { el.classList.contains('is-open') ? this.hide(el) : this.show(el, opener); }
  };
  window.PurusDrawers = Drawers;
  if (window.Shopify && window.Shopify.designMode) {
    // Inside the editor a fixed-position body would freeze the preview; a plain overflow lock is enough there.
    ScrollLock.lock = function () { document.body.classList.add('drawer-open'); this.locked = true; };
    ScrollLock.unlock = function () { document.body.classList.remove('drawer-open'); this.locked = false; };
  }
  window.addEventListener('pageshow', () => { if (!Drawers.open) ScrollLock.unlock(); });

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      const target = document.getElementById(opener.getAttribute('data-drawer-open'));
      if (target) { e.preventDefault(); Drawers.show(target, opener); }
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { const d = closer.closest('.drawer'); if (d) { if (closer.tagName === 'BUTTON') e.preventDefault(); Drawers.hide(d); } return; }
    if (e.target === overlay && Drawers.open) Drawers.hide(Drawers.open);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (Drawers.open) Drawers.hide(Drawers.open);
      $$('.header__nav-item.is-open').forEach((i) => { i.classList.remove('is-open'); const t = $('.header__link', i); if (t) t.setAttribute('aria-expanded', 'false'); });
      $$('.header--menu-open').forEach((h) => h.classList.remove('header--menu-open'));
    }
    // Keep Tab inside the open drawer
    if (e.key === 'Tab' && Drawers.open) {
      const nodes = $$(FOCUSABLE, Drawers.open).filter((n) => n.offsetParent !== null);
      if (!nodes.length) return;
      const first = nodes[0], last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Announcement rotator ---------- */
  function initAnnouncements(ctx) {
    $$('[data-announcement]', ctx).forEach((bar) => {
      if (!once(bar, 'Ann')) return;
      const items = $$('.announcement__item', bar);
      if (items.length < 2) return;
      let i = Math.max(0, items.findIndex((el) => el.classList.contains('is-active')));
      const delay = Number(bar.dataset.delay || 5000);
      let timer;
      const go = (n) => { items[i].classList.remove('is-active'); i = (n + items.length) % items.length; items[i].classList.add('is-active'); };
      const stop = () => clearInterval(timer);
      const start = () => { stop(); if (!reduceMotion) timer = setInterval(() => go(i + 1), delay); };
      $('[data-announcement-prev]', bar)?.addEventListener('click', () => { go(i - 1); start(); });
      $('[data-announcement-next]', bar)?.addEventListener('click', () => { go(i + 1); start(); });
      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', start);
      bar.showItem = (el) => { const n = items.indexOf(el); if (n >= 0) { stop(); go(n); } };
      start();
    });
  }

  /* ---------- Header ---------- */
  function initHeader(ctx) {
    $$('[data-header]', ctx).forEach((header) => {
      if (!once(header, 'Header')) return;
      // The header group is sticky with its own stacking context, so drawers rendered inside it would sit
      // beneath the page overlay (greyed out, taps blocked). Move them to <body>, replacing any earlier copy.
      try {
        const sectionEl = header.closest('.shopify-section') || header.parentElement;
        $$('.drawer', sectionEl).forEach((d) => {
          if (d.id) $$('body > #' + d.id).forEach((old) => { if (old !== d) old.remove(); });
          document.body.appendChild(d);
        });
      } catch (err) { console.warn('drawer portal', err); }
      const body = document.body;
      const onScroll = () => body.classList.toggle('header-scrolled', window.scrollY > 24);
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
      $$('.header__nav-item--has-mega', header).forEach((item) => {
        const trigger = $('.header__link', item);
        let hoverTimer;
        const open = () => { $$('.header__nav-item.is-open', header).forEach((o) => { if (o !== item) o.classList.remove('is-open'); }); item.classList.add('is-open'); header.classList.add('header--menu-open'); trigger.setAttribute('aria-expanded', 'true'); };
        const close = () => { item.classList.remove('is-open'); if (!$('.header__nav-item.is-open', header)) header.classList.remove('header--menu-open'); trigger.setAttribute('aria-expanded', 'false'); };
        item.addEventListener('mouseenter', () => { clearTimeout(hoverTimer); open(); });
        item.addEventListener('mouseleave', () => { hoverTimer = setTimeout(close, 120); });
        trigger.addEventListener('click', (e) => {
          if (window.matchMedia('(hover: none)').matches || e.detail === 0) { e.preventDefault(); item.classList.contains('is-open') ? close() : open(); }
        });
        item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) close(); });
      });
    });
  }

  /* ---------- Carousels (scroll-snap + progress + arrows) ---------- */
  class Carousel {
    constructor(root) {
      this.root = root;
      this.viewport = $('.carousel__viewport', root);
      this.track = $('.carousel__track', root);
      this.bar = $('.carousel__progress-bar', root);
      this.prev = $('.carousel__arrow--prev', root);
      this.next = $('.carousel__arrow--next', root);
      if (!this.viewport) return;
      this.update = this.update.bind(this);
      this.viewport.addEventListener('scroll', () => requestAnimationFrame(this.update), { passive: true });
      window.addEventListener('resize', this.update);
      this.prev?.addEventListener('click', () => this.step(-1));
      this.next?.addEventListener('click', () => this.step(1));
      this.update();
    }
    slideWidth() {
      const slide = $('.carousel__slide', this.root);
      if (!slide) return this.viewport.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }
    step(dir) { this.viewport.scrollBy({ left: dir * this.slideWidth(), behavior: reduceMotion ? 'auto' : 'smooth' }); }
    update() {
      const v = this.viewport;
      const max = v.scrollWidth - v.clientWidth;
      if (this.bar && v.scrollWidth > 0) {
        const ratio = Math.min(1, v.clientWidth / v.scrollWidth);
        const pos = max > 0 ? v.scrollLeft / max : 0;
        this.bar.style.width = (ratio * 100) + '%';
        this.bar.style.transform = 'translateX(' + (pos * (100 / ratio - 100)) + '%)';
      }
      if (this.prev) this.prev.disabled = v.scrollLeft <= 2;
      if (this.next) this.next.disabled = v.scrollLeft >= max - 2;
    }
  }
  function initCarousels(ctx) { $$('[data-carousel]', ctx).forEach((c) => { if (once(c, 'Car')) new Carousel(c); }); }

  /* ---------- Segmented tabs (product carousel collections) ---------- */
  function initTabs(ctx) {
    $$('[data-tabs]', ctx).forEach((root) => {
      if (!once(root, 'Tabs')) return;
      const tabs = $$('[role="tab"]', root);
      const panels = $$('[role="tabpanel"]', root);
      if (!tabs.length) return;
      const activate = (tab) => {
        tabs.forEach((t) => { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); t.tabIndex = t === tab ? 0 : -1; });
        panels.forEach((p) => { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
        window.dispatchEvent(new Event('resize'));
      };
      tabs.forEach((tab, idx) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            const n = (idx + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
            tabs[n].focus(); activate(tabs[n]);
          }
        });
      });
    });
  }

  /* ---------- Single-open accordions ---------- */
  function initAccordions(ctx) {
    $$('[data-accordion-single]', ctx).forEach((root) => {
      if (!once(root, 'Acc')) return;
      $$('details', root).forEach((d) => {
        d.addEventListener('toggle', () => { if (d.open) $$('details', root).forEach((o) => { if (o !== d) o.open = false; }); });
      });
    });
  }

  /* ---------- Product gallery ---------- */
  class Gallery {
    constructor(root) {
      this.root = root;
      this.track = $('.gallery__track', root);
      this.slides = $$('.gallery__slide', root);
      this.thumbs = $$('.gallery__thumb', root);
      this.dots = $$('.gallery__dot', root);
      this.index = 0;
      if (!this.track || this.slides.length < 2) return;
      $('.gallery__arrow--prev', root)?.addEventListener('click', () => this.go(this.index - 1));
      $('.gallery__arrow--next', root)?.addEventListener('click', () => this.go(this.index + 1));
      this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.go(i)));
      let start = null;
      this.track.addEventListener('touchstart', (e) => { start = { x: e.touches[0].clientX, y: e.touches[0].clientY }; }, { passive: true });
      this.track.addEventListener('touchend', (e) => {
        if (!start) return;
        const dx = e.changedTouches[0].clientX - start.x, dy = e.changedTouches[0].clientY - start.y;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) this.go(this.index + (dx < 0 ? 1 : -1));
        start = null;
      }, { passive: true });
      root.addEventListener('keydown', (e) => { if (e.key === 'ArrowLeft') this.go(this.index - 1); if (e.key === 'ArrowRight') this.go(this.index + 1); });
    }
    go(i) {
      if (!this.track) return;
      this.index = (i + this.slides.length) % this.slides.length;
      this.track.style.transform = 'translateX(-' + (this.index * 100) + '%)';
      this.thumbs.forEach((t, n) => t.setAttribute('aria-current', n === this.index ? 'true' : 'false'));
      this.dots.forEach((d, n) => d.setAttribute('aria-current', n === this.index ? 'true' : 'false'));
      this.slides.forEach((s, n) => { s.setAttribute('aria-hidden', n === this.index ? 'false' : 'true'); if (n !== this.index) s.querySelectorAll('video').forEach((v) => v.pause()); });
      const thumb = this.thumbs[this.index];
      if (thumb && thumb.parentElement) {
        const strip = thumb.parentElement;
        strip.scrollTo({ left: thumb.offsetLeft - strip.clientWidth / 2 + thumb.clientWidth / 2, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }
    goToMedia(mediaId) {
      const i = this.slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
      if (i >= 0) this.go(i);
    }
  }

  /* ---------- Facts tabs ---------- */
  function initFacts(ctx) {
    $$('[data-facts]', ctx).forEach((root) => {
      if (!once(root, 'Facts')) return;
      const tabs = $$('.facts__tab', root);
      const panels = $$('.facts__panel', root);
      tabs.forEach((tab) => tab.addEventListener('click', () => {
        tabs.forEach((t) => t.setAttribute('aria-selected', t === tab ? 'true' : 'false'));
        panels.forEach((p) => { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
      }));
    });
  }

  /* ---------- Product form (variants + selling plans + sticky bar) ---------- */
  class ProductForm {
    constructor(root) {
      this.root = root;
      const dataEl = $('[data-product-json]', root);
      this.form = $('form[data-product-form]', root);
      if (!dataEl || !this.form) { const g = $('[data-gallery]', root); if (g) new Gallery(g); return; }
      this.product = JSON.parse(dataEl.textContent);
      this.variants = this.product.variants;
      this.idInput = $('input[name="id"]', this.form);
      this.planInput = $('input[name="selling_plan"]', this.form);
      this.qtyInput = $('input[name="quantity"]', this.form);
      this.pills = $$('[data-option-pill]', root);
      this.plans = $$('[data-plan]', root);
      this.freqSelect = $('[data-plan-frequency]', root);
      this.atc = $('[data-atc]', root);
      this.stickyAtc = $('[data-sticky-atc]', root);
      this.sticky = $('[data-sticky-bar]', root);
      this.gallery = $('[data-gallery]', root) ? new Gallery($('[data-gallery]', root)) : null;
      this.currentVariant = this.variants.find((v) => String(v.id) === String(this.idInput && this.idInput.value)) || this.variants[0];
      this.bind();
      this.render();
      this.setupSticky();
    }
    bind() {
      this.pills.forEach((pill) => {
        const input = $('input', pill);
        input.addEventListener('change', () => {
          this.pills.filter((p) => p.dataset.optionIndex === pill.dataset.optionIndex).forEach((p) => p.classList.remove('is-selected'));
          pill.classList.add('is-selected');
          this.onOptionChange();
        });
      });
      this.plans.forEach((plan) => $('input', plan).addEventListener('change', () => this.render()));
      this.freqSelect?.addEventListener('change', () => this.render());
      $$('[data-qty-minus]', this.root).forEach((b) => b.addEventListener('click', () => this.setQty(this.qty() - 1)));
      $$('[data-qty-plus]', this.root).forEach((b) => b.addEventListener('click', () => this.setQty(this.qty() + 1)));
      this.form.addEventListener('submit', (e) => this.submit(e));
      this.stickyAtc?.addEventListener('click', (e) => { e.preventDefault(); if (this.form.requestSubmit) this.form.requestSubmit(); else this.submit(e); });
    }
    qty() { return Math.max(1, parseInt(this.qtyInput && this.qtyInput.value, 10) || 1); }
    setQty(n) { if (this.qtyInput) this.qtyInput.value = Math.max(1, n); this.render(); }
    selectedOptions() {
      const groups = {};
      this.pills.forEach((p) => { const i = Number(p.dataset.optionIndex); if ($('input', p).checked) groups[i] = $('input', p).value; });
      return Object.keys(groups).map(Number).sort((a, b) => a - b).map((k) => groups[k]);
    }
    onOptionChange() {
      const opts = this.selectedOptions();
      opts.forEach((val, i) => { const el = $('[data-option-selected="' + i + '"]', this.root); if (el) el.textContent = val; });
      const match = this.variants.find((v) => v.options.every((o, i) => o === opts[i]));
      if (match) this.currentVariant = match;
      this.render();
      if (match) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
        if (this.gallery && match.featured_media) this.gallery.goToMedia(match.featured_media.id);
      }
    }
    selectedPlan() {
      const plan = this.plans.find((p) => $('input', p).checked);
      if (!plan || plan.dataset.plan === 'onetime') return null;
      const id = this.freqSelect ? this.freqSelect.value : plan.dataset.planId;
      return id || null;
    }
    allocationFor(variant, planId) {
      if (!planId || !variant.selling_plan_allocations) return null;
      return variant.selling_plan_allocations.find((a) => String(a.selling_plan_id) === String(planId)) || null;
    }
    render() {
      const v = this.currentVariant;
      const planId = this.selectedPlan();
      const alloc = this.allocationFor(v, planId);
      const planSelected = !!planId && !!alloc;
      const strings = S();
      if (this.idInput) this.idInput.value = v.id;
      if (this.planInput) { this.planInput.value = planSelected ? planId : ''; this.planInput.disabled = !planSelected; }
      this.plans.forEach((p) => { const on = $('input', p).checked; p.classList.toggle('is-selected', on); p.dataset.selected = on ? 'true' : 'false'; });
      const onetimeEl = $('[data-plan="onetime"] [data-plan-price]', this.root);
      if (onetimeEl) onetimeEl.innerHTML = this.priceHtml(v.price, v.compare_at_price, false);
      const subPriceEl = $('[data-plan="subscribe"] [data-plan-price]', this.root);
      if (subPriceEl) {
        const a = alloc || (v.selling_plan_allocations && v.selling_plan_allocations[0]);
        subPriceEl.innerHTML = a ? this.priceHtml(a.price, v.price, true) : this.priceHtml(v.price, v.compare_at_price, false);
      }
      const activePrice = alloc ? alloc.price : v.price;
      const activeCompare = alloc ? v.price : v.compare_at_price;
      const priceEl = $('[data-price]', this.root);
      if (priceEl) priceEl.innerHTML = this.priceHtml(activePrice, activeCompare, !!alloc);
      const unitEl = $('[data-unit-price]', this.root);
      if (unitEl) {
        const unitPrice = alloc && alloc.unit_price ? alloc.unit_price : v.unit_price;
        const m = v.unit_price_measurement;
        if (unitPrice && m && m.reference_value) { unitEl.textContent = window.PurusMoney(unitPrice) + ' / ' + m.reference_value + m.reference_unit; unitEl.hidden = false; }
        else unitEl.hidden = true;
      }
      const qtyLabel = $('[data-qty-label]', this.root);
      if (qtyLabel) qtyLabel.textContent = (strings.qty || 'Qty') + ' ' + this.qty();
      const variantLabel = $('[data-variant-label]', this.root);
      if (variantLabel) variantLabel.textContent = v.title === 'Default Title' ? this.product.title : v.title;
      const atcText = !v.available ? strings.soldOut : (planSelected ? strings.subscribe : strings.addToCart);
      if (this.atc) { this.atc.disabled = !v.available; const l = $('.btn__label', this.atc); if (l) l.textContent = atcText; }
      if (this.sticky) {
        const st = $('[data-sticky-variant]', this.sticky);
        const sp = $('[data-sticky-price]', this.sticky);
        const sb = $('[data-sticky-badge]', this.sticky);
        const planName = planSelected && this.freqSelect ? this.freqSelect.options[this.freqSelect.selectedIndex].text : '';
        if (st) st.textContent = (v.title === 'Default Title' ? '' : v.title) + (planName ? (v.title === 'Default Title' ? '' : ' \u00b7 ') + planName : '');
        if (sp) sp.innerHTML = this.priceHtml(activePrice, activeCompare, !!alloc);
        if (sb) {
          const pct = alloc && v.price ? Math.round((1 - alloc.price / v.price) * 100) : 0;
          sb.hidden = !(alloc && pct > 0);
          if (alloc && pct > 0) sb.textContent = (strings.save || 'Save') + ' ' + pct + '%';
        }
        if (this.stickyAtc) { this.stickyAtc.disabled = !v.available; const l = $('.btn__label', this.stickyAtc); if (l) l.textContent = atcText; else this.stickyAtc.textContent = atcText; }
      }
      document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v, plan: planId, form: this } }));
    }
    priceHtml(price, compare, sale) {
      let html = '<span class="price__current">' + window.PurusMoney(price) + '</span>';
      if (compare && compare > price) html = '<s class="price__compare">' + window.PurusMoney(compare) + '</s> ' + html;
      return '<span class="price' + (compare && compare > price ? (sale ? ' price--plan' : ' price--sale') : '') + '">' + html + '</span>';
    }
    async submit(e) {
      if (e) e.preventDefault();
      if (!this.atc || this.atc.disabled) return;
      const btn = this.atc;
      const msg = $('[data-form-error]', this.root);
      if (msg) msg.hidden = true;
      btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
      const fd = new FormData(this.form);
      if (!this.selectedPlan()) fd.delete('selling_plan');
      try {
        if (window.PurusCart) await window.PurusCart.add(fd);
        else { await fetch(window.PurusTheme.routes.cartAdd + '.js', { method: 'POST', body: fd }); window.location.href = window.PurusTheme.routes.cart; }
      } catch (err) {
        if (msg) { msg.textContent = (err && err.message) || S().cartError; msg.hidden = false; }
      } finally {
        btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy');
      }
    }
    setupSticky() {
      if (!this.sticky || !('IntersectionObserver' in window)) return;
      const trigger = $('[data-sticky-trigger]', this.root) || this.form;
      const io = new IntersectionObserver((entries) => {
        const en = entries[0];
        const below = en.boundingClientRect.top < 0 && !en.isIntersecting;
        this.sticky.classList.toggle('is-visible', below);
        this.sticky.setAttribute('aria-hidden', below ? 'false' : 'true');
        document.body.classList.toggle('sticky-atc-visible', below);
      }, { threshold: 0 });
      io.observe(trigger);
    }
  }
  function initProducts(ctx) { $$('[data-product]', ctx).forEach((p) => { if (once(p, 'Prod')) new ProductForm(p); }); }

  /* ---------- Quick add (cards / cart recommendations) ---------- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const id = btn.getAttribute('data-quick-add');
    if (!id || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    const fd = new FormData();
    fd.append('id', id); fd.append('quantity', '1');
    try { if (window.PurusCart) await window.PurusCart.add(fd); }
    catch (err) { console.warn(err); }
    finally { btn.classList.remove('is-loading'); }
  });

  /* ---------- Marquee speed by content width ---------- */
  function initMarquees(ctx) {
    $$('[data-marquee]', ctx).forEach((m) => {
      if (!once(m, 'Marq')) return;
      const group = $('.marquee__group, .ugc__group', m);
      if (!group) return;
      const speed = Number(m.dataset.speed || 60); // px per second
      const set = () => { m.style.setProperty('--marquee-speed', Math.max(12, group.scrollWidth / speed) + 's'); };
      set(); window.addEventListener('resize', set);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(set);
    });
  }

  /* ---------- Slideshow (hero slides, dots, autoplay) ---------- */
  function initSlideshows(ctx) {
    $$('[data-slideshow]', ctx).forEach((root) => {
      if (!once(root, 'Slides')) return;
      const track = $('.slideshow__track', root);
      const slides = $$('.slideshow__slide', root);
      const dots = $$('[data-slideshow-dot]', root);
      if (!track || slides.length < 2) return;
      let i = 0, timer;
      const go = (n) => {
        i = (n + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + (i * 100) + '%)';
        dots.forEach((d, k) => d.setAttribute('aria-selected', k === i ? 'true' : 'false'));
        slides.forEach((sl, k) => sl.setAttribute('aria-hidden', k === i ? 'false' : 'true'));
      };
      const stop = () => clearInterval(timer);
      const start = () => { stop(); if (root.dataset.autoplay === 'true' && !reduceMotion) timer = setInterval(() => go(i + 1), Number(root.dataset.delay || 6000)); };
      $('[data-slideshow-prev]', root)?.addEventListener('click', () => { go(i - 1); start(); });
      $('[data-slideshow-next]', root)?.addEventListener('click', () => { go(i + 1); start(); });
      dots.forEach((d) => d.addEventListener('click', () => { go(Number(d.dataset.slideshowDot)); start(); }));
      root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', start);
      let sx = null, sy = null;
      root.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      root.addEventListener('touchend', (e) => { if (sx === null) return; const dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) { go(i + (dx < 0 ? 1 : -1)); start(); } sx = sy = null; }, { passive: true });
      root.showSlide = (el) => { const n = slides.indexOf(el); if (n >= 0) { stop(); go(n); } };
      go(0); start();
    });
  }

  /* ---------- Video: swap cover image for the embed on click ---------- */
  document.addEventListener('click', (e) => {
    const poster = e.target.closest('[data-video-play]');
    if (!poster) return;
    const frame = poster.closest('[data-video]');
    const tpl = frame && $('[data-video-embed]', frame);
    if (!tpl) return;
    frame.innerHTML = tpl.innerHTML;
  });

  /* ---------- Predictive search drawer ---------- */
  function initPredictiveSearch(ctx) {
    $$('[data-predictive-form]', ctx).forEach((form) => {
      if (!once(form, 'Pred')) return;
      const input = $('[data-predictive-input]', form);
      const container = form.parentElement && $('[data-predictive-container]', form.parentElement);
      if (!input || !container) return;
      let timer, controller;
      const run = async () => {
        const q = input.value.trim();
        if (controller) controller.abort();
        if (q.length < 2) { container.innerHTML = ''; return; }
        controller = new AbortController();
        container.classList.add('is-loading');
        try {
          const url = window.PurusTheme.routes.predictiveSearch + '?q=' + encodeURIComponent(q) + '&resources[type]=product,page,article&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor&section_id=predictive-search';
          const res = await fetch(url, { signal: controller.signal });
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const results = $('[data-predictive-results]', doc);
          container.innerHTML = results ? results.outerHTML : '';
        } catch (err) { if (err.name !== 'AbortError') console.warn(err); }
        finally { container.classList.remove('is-loading'); }
      };
      input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(run, 220); });
    });
  }

  /* ---------- Collection filters / sort: submit the form on change ---------- */
  function initFilters(ctx) {
    $$('[data-filter-form]', ctx).forEach((form) => {
      if (!once(form, 'Filt')) return;
      let timer;
      form.addEventListener('change', (e) => {
        if (!e.target.closest('[data-filter-input]')) return;
        clearTimeout(timer);
        const isPrice = e.target.type === 'number';
        timer = setTimeout(() => {
          $$('input[type="number"]', form).forEach((n) => { if (n.value === '') n.disabled = true; });
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
        }, isPrice ? 500 : 0);
      });
    });
  }

  /* ---------- Product recommendations (Shopify API + Section Rendering) ---------- */
  function initRelated(ctx) {
    $$('[data-related]', ctx).forEach(async (el) => {
      if (!once(el, 'Rel')) return;
      const pid = el.dataset.productId;
      if (!pid) return;
      try {
        const url = window.PurusTheme.routes.productRecommendations + '?section_id=' + encodeURIComponent(el.dataset.sectionId) + '&product_id=' + pid + '&limit=' + (el.dataset.limit || 4) + '&intent=' + (el.dataset.intent || 'related');
        const res = await fetch(url);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = $('[data-related]', doc);
        if (fresh && $('[data-carousel]', fresh)) { el.innerHTML = fresh.innerHTML; el.hidden = false; initCarousels(el); }
        else el.hidden = true;
      } catch (err) { el.hidden = true; }
    });
  }

  /* ---------- Init (page load + theme editor section loads) ---------- */
  function initAll(ctx) {
    initAnnouncements(ctx); initHeader(ctx); initCarousels(ctx); initTabs(ctx); initAccordions(ctx); initFacts(ctx); initProducts(ctx); initMarquees(ctx);
    initSlideshows(ctx); initPredictiveSearch(ctx); initFilters(ctx); initRelated(ctx);
  }
  initAll(document);

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => { if (Drawers.open) Drawers.hide(Drawers.open); initAll(e.target); });
    document.addEventListener('shopify:section:unload', () => { if (Drawers.open) Drawers.hide(Drawers.open); ScrollLock.unlock(); });
    document.addEventListener('shopify:block:select', (e) => {
      const block = e.target;
      const details = block.closest('details') || (block.matches('details') ? block : null);
      if (details) details.open = true;
      const item = block.closest('.announcement__item');
      const bar = item && item.closest('[data-announcement]');
      if (bar && bar.showItem) bar.showItem(item);
      const slide = block.closest('.slideshow__slide');
      const show = slide && slide.closest('[data-slideshow]');
      if (show && show.showSlide) show.showSlide(slide);
    });
    // Selecting the cart drawer section in the editor opens it; deselecting closes it
    document.addEventListener('shopify:section:select', (e) => {
      const drawer = $('.cart-drawer', e.target);
      if (drawer && !drawer.classList.contains('is-open')) Drawers.show(drawer);
    });
    document.addEventListener('shopify:section:deselect', (e) => {
      const drawer = $('.cart-drawer', e.target);
      if (drawer && drawer.classList.contains('is-open')) Drawers.hide(drawer);
    });
  }
})();